import Vue from 'vue';
import { MUTATIONS, STATUS } from '../constants';

const initialise = (status, init) => (state) => {
  Vue.set(state, 'paginator', status);
  if (!state[status]) {
    Vue.set(state, status, { ...init });
  } else {
    Vue.assign(state[status], { ...init });
  }
};

export default (cfg) => {
  const init = {
    page: 1,
    pageSize: cfg.pageSize || 50,
  };
  return {
    [MUTATIONS.INIT]: initialise(STATUS.loading, init),
    [MUTATIONS.UPDATING]: initialise(STATUS.updating, init),
    [MUTATIONS.PAGINATION.NEXT_PAGE](state) {
      state[state.paginator].page += 1;
    },
    [MUTATIONS.HEADERS](state, { records }) {
      Vue.set(state[state.paginator], 'totalRecords', Number.parseInt(records, 10));
    },
    // When the loading has finished, reset the paginator
    // to the loading one. This means the 'hasMore' getter
    // will work.
    [MUTATIONS.LOADED](state) {
      state.paginator = STATUS.loading;
    },
  };
};
